import { get } from "frontend/utils/api"
import { trackABTestsUpdate } from "../tracking/amplitude/ab-test-identify"

let loadTestPromise = null

const getTestValueFromWindow = (testName) => {
  if (window.ab_tests[testName]) {
    return window.ab_tests[testName].value
  } else {
    return null
  }
}

const getFlagValueFromWindow = (flagName) => {
  if (flagName in window.feature_flags) {
    return window.feature_flags[flagName]
  } else {
    return null
  }
}

const isValidArray = (arr) => Array.isArray(arr) && arr.length

const getNewAssignments = (assignments) => {
  let newAssignments = []
  if (isValidArray(assignments)) {
    newAssignments = assignments.filter((assignValue) => !getTestValueFromWindow(assignValue))
  }
  return isValidArray(newAssignments) ? newAssignments : null
}

const getNewAssignmentsQuery = (assignments) => {
  const newAssignments = getNewAssignments(assignments)

  return newAssignments ? `?${newAssignments.map((newAssignment) => `assign[]=${newAssignment}`).join("&")}` : ""
}

export const loadTests = async (assignments) => {
  const testsPath = "/ab_tests"
  const newAssignments = getNewAssignments(assignments)

  // if there are assign values we need to do the fetch
  if (!loadTestPromise || newAssignments) {
    const assignmentsQuery = getNewAssignmentsQuery(newAssignments)

    loadTestPromise = get(`${testsPath}${assignmentsQuery}`)
  }
  const result = await loadTestPromise

  if (result && result.status === 200) {
    window.feature_flags = result.data.feature_flags
    window.ab_tests = result.data.ab_tests

    // amplitude tracking
    if (newAssignments) {
      trackABTestsUpdate(window.ab_tests)
    }
  } else {
    console.warn("Failed to load AB test assignments")
  }
}

export const getFlagValue = async (flagName) => {
  if (!window.feature_flags) {
    await loadTests()
  }
  return getFlagValueFromWindow(flagName)
}

export const getTestValue = async (testName) => {
  if (!getTestValueFromWindow(testName)) {
    await loadTests([testName]) // we send the assign to get the value
  }
  return getTestValueFromWindow(testName)
}

export const getTests = async (assignments) => {
  if (getNewAssignments(assignments) || !window.ab_tests) {
    await loadTests(assignments)
  }
  return window.ab_tests
}

export const getFlags = async () => {
  if (!window.feature_flags) {
    await loadTests()
  }
  return window.feature_flags
}
